const en = {
  name: "Name",
  category: "Category",
  addProduct: "Add a new product",
  addOrEditProduct: "Add/Edit Product",
  addOrEditCategoryProduct: "Add/Edit Category Product",
  editCategoryInfo: "Edit Category Info",
  plCode: "Please enter the category code",
  plName: "Please enter the category name",
  selCategory: "Please select the product category",
  code: "Code",
  addCategory: "Add a new category",
  addSubCategory: "Add a new subcategory",
  noDelTips1: "There are products under this category and cannot be deleted. ",
  tips: "Tips",
  conTips: "Are you sure you want to delete this category? ",
  noDelTips2: "There are subcategories under this category and cannot be deleted. ",
  plEnterName: "Please enter the category name",
  productList: "Product list",
  delCategory: "Delete category",
  plSearch: "Please enter keywords to search",
  fetchFail: "Product category query failed",

  storeType: "Inventory type:",
  storeTypeCloumn: "Inventory type",
  storeTypeNum: "Quantity",
  storeTypeCode: "Barcode",
  hsCode: 'HS Code',
  plHsCode: 'Please enter the HS Code',
  plChooseType: 'Please select type',
  all: 'All',
  setCategoryOrg: 'Set Category Org'
};

export default en;